import React, {Component} from 'react';
import Table from '../../../components/table/Table';
import {Col, Button, Card, CardBody, ButtonToolbar, Row} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as http from '../../../modules/http';
import CheckBox from "../../../components/CheckBox";
import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from '../../../modules/environment';
import Alert from '../../../components/Alert';
import Modal from "./Modal";
import ModalTrue from '../../../components/ModalTrue';
import {round10} from "../../../modules/common"


class EquipmentTableForOrdering extends Component {

    constructor(props) {
        super(props);
        this.state = {
            order: '',
            orders:[],
            warning: '',
            saving: false,
            error: false,
            saved: false
        };
    }

    componentDidMount() {

        let orders = [];

        for(let index in this.props.data) {
            orders.push({providerId: this.props.data[index].id, count: "",
                price: this.props.data[index].price, profit: this.props.data[index].profit,
                name: this.props.data[index].name});
        }

        this.setState({orders: orders});
    }

    chooseProvider = (id, e) => {
        let tmp = this.state.order.split(',');

        if (e === true) {
            if (!tmp.includes(id.toString())) {
                let ids = this.state.order;
                if (ids === "")
                    this.setState({order: id.toString()});
                else
                    this.setState({order: ids.concat("," + id.toString())});
            }
        }
        else {
            if (tmp.includes(id.toString())) {
                let res = "";
                let idString = id.toString();
                for (let index in tmp) {
                    if (idString !== tmp[index]) {
                        if (res === "")
                            res += tmp[index];
                        else
                            res += "," + tmp[index];
                    }
                }

                this.setState({order: res});
            }
        }
    };

    changeCount = (id, e) => {

        let updatedData = [];

        for(let index in this.state.orders) {
            if(this.state.orders[index].providerId === id) {
                updatedData.push({providerId: this.state.orders[index].providerId, count: e,
                    price: this.state.orders[index].price, profit: this.state.orders[index].profit,
                    name: this.state.orders[index].name});
            }
            else {
                updatedData.push(this.state.orders[index]);
            }
        }

        this.setState({orders: updatedData});
    };

    orderItem = (item) => {
        http.postToServer(
            'equip/equip_order?name=' + item.name + '&id=' + item.id,
            {},
            (response) => {
                this.setState({saved: true});
            },
            (response) => {
                console.log('error equip_order add');
            }
        );
    };

    calculatePrice = () => {

        let totalPrice = 0;

        if(this.state.order !== '') {
            let chosenAcc = this.state.order.split(',');
            let data = chosenAcc.map(e => this.state.orders.find((a) => parseInt(e) === a.providerId));

            for(let i in data) {

                if(data[i].count !== '') {
                    let price = parseInt(data[i].count) * (parseFloat(data[i].price) + parseFloat(data[i].price) * (parseFloat(data[i].profit) * 0.01));

                    price = round10(price, -1);
                    totalPrice = totalPrice + price;
                }
            }
        }

        //console.log(totalPrice)

        return totalPrice;
    };

    sendOrder = () => {

        let chosenAcc = this.state.order.split(',');

        let data = chosenAcc.map(e => this.state.orders.find((a) => parseInt(e) === a.providerId));

        if(this.state.order === '') {
            this.setState({warning: "אנא בחר ציוד"});
            return;
        }

        for(let i in data) {
            if(data[i].count === '') {
                this.setState({warning: "אנא בחר כמות"});
                return;
            }
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            storeId: this.props.userData.data.id,
            order: this.state.order,
            data: data
        };

        http.postToServer(
            'equip/equip_order',
            storeData,
            (response) => {
                this.setState({saving: false, error: false, success: true, order: '', saved: true});

                //this.props.dispatch(fetchOrdersDataForce(this.queryParams));
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );
    };

    getRow(provider, index, chosenAcc) {

        let logoUrl = environment.getServerBasePath() + '/equip/equip_download?equipID=' + provider.id;

        let res = chosenAcc.includes((provider.id).toString());
        let data = {count: ""};

        if(this.state.orders && this.state.orders !== [] && this.state.orders.length > 0) {
            data = this.state.orders.find((e) => e.providerId === provider.id);
        }

        //console.log('Price ' +  provider.price);

        let totalPrice = parseFloat(provider.price) + parseFloat(provider.price) * (parseFloat(provider.profit) * 0.01);

        totalPrice = round10(totalPrice, -1);

        return (

            <React.Fragment key={provider.id}>

                <tr key={provider.id}>

                    <td>
                        <CheckBox
                            label='להזמין'
                            name={provider.name}
                            value={res}
                            onChange={(e) => this.chooseProvider(provider.id, e)}/>
                    </td>

                    <td>
                        <form className='topbar__search material-form'>
                            <div className='search_field_form_control  topbar__search-field'>
                                <div className='search_field_root search_field_custom-underline'
                                     style={{border: 'groove'}}>
                                    <input className='search_field_custom-input' dir="rtl"
                                           style={!res ? {
                                                   backgroundColor: '#DCDCDC',
                                                   width: '100%'
                                               } :
                                               {backgroundColor: '#F0F8FF', width: '100%'}}
                                           placeholder="כמות"
                                           value={data.count}
                                           disabled={!res}
                                           type="number"
                                           onChange={(e) => this.changeCount(provider.id, e.target.value)}/>
                                </div>
                            </div>
                        </form>
                    </td>

                    <td>{provider.text}</td>
                    <td>{provider.serialNumber}</td>
                    <td>{totalPrice}</td>
                    <td>
                        <img src={logoUrl} style={{maxWidth: '200px', objectFit: 'cover' }}/>
                    </td>
                    <td>{provider.name}</td>

                </tr>

                {this.props.provider && provider.id === this.props.provider.id &&
                <tr key={provider.id + 2000}>
                    <td colSpan="7">
                        {/*<EditEquipmentForm  index={index} onClose={() => this.props.dispatch(providers_open_form(provider))}/>*/}
                    </td>
                </tr>}
            </React.Fragment>
        );
    }

    render() {

        //console.log(this.state.order);
        /*const rows = this.props.data.map((category, index) =>
            category.data.map((item) => this.getRow(item, index))
        );*/

        let isStore = true;
        if (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.isAdmin || this.props.userData.data.isManager)) {
            isStore = false;
        }

        let chosenAcc = this.state.order.split(',');

        let data = undefined;

        if(this.state.order !== '') {
            data = chosenAcc.map(e => this.state.orders.find((a) => parseInt(e) === a.providerId));
        }

        const rows = this.props.data.map((item, index) => this.getRow(item, index, chosenAcc));

        let totalPrice = this.calculatePrice();

        let totalPriceStr = "";

        if(totalPrice !== 0) {
            totalPriceStr = " סהכ להזמנה זו " + ":" +  " = " + totalPrice + " ₪" + " לפני מעמ "
        }

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                {this.state.warning !== '' &&
                <Row >
                    <Alert color='warning' className='alert--bordered' icon >
                        <p><span style={{float: 'right'}}
                                 className='bold-text'>{this.state.warning}</span>
                        </p>
                    </Alert>
                </Row>}
                {this.state.saved &&
                <ModalTrue color='success' title={TextManager.getCurrentTextResource().Text.wellDone} noCancel
                           message='הזמנה בוצעה בהצלחה'
                           approve={() => this.setState({saved: false})}/>
                }
                <Card>
                    <CardBody>

                        <Table responsive className='table--bordered' dir="rtl">
                            <thead>
                            <tr>

                                <th></th>
                                <th>כמות</th>
                                <th>תיאור</th>
                                <th>מקט</th>
                                <th>מחיר עלות לפני מעמ</th>
                                <th>{TextManager.getCurrentTextResource().Providers.image}</th>
                                <th>שם ציוד</th>

                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>

                        {isStore && data !== undefined && data.map((item,i) => {
                            //console.log(item)

                            let price = parseFloat(item.price) + parseFloat(item.price) * (parseFloat(item.profit) * 0.01);
                            price = round10(price, -1);

                            let totalPrice = price * parseInt(item.count);
                            totalPrice = round10(totalPrice, -1);

                            if(item.count !== '') {
                                //let text = item.name + ": " + price + " ₪ * " + item.count + " = " + totalPrice + " ₪ ";
                                let text = " ₪ " + totalPrice +  " = " + item.count  + " * ₪ " + price  + ":" + item.name;
                                return(
                                    <Row>
                                        <Col md={2} sm={12} lg={2} xs={12}>
                                            <h5 className='bold-text'>
                                                {text}
                                            </h5>
                                        </Col>
                                    </Row>
                                )
                            }
                            else {
                                return(<div></div>)
                            }
                        })}

                        {isStore && totalPrice !== 0 && <Row>
                            <Col md={2} sm={12} lg={2} xs={12}>
                                <h5 className='bold-text'>
                                    {totalPriceStr}
                                </h5>
                            </Col>
                        </Row>}

                        <Row>
                            <Col md={6} sm={12} lg={6} xs={12}>
                                <Modal color='primary' title='Are you sure!'
                                       approve={() => this.sendOrder()}
                                       message={isStore ? '? ₪ ' + 'לשלוח הזמנות של ' + totalPrice : '?לשלוח הזמנות'}>
                                    <ButtonToolbar className="form__button-toolbar" style={{padding: '15px'}}>
                                        <Button color='primary' onClick={(e) => e.preventDefault()}>
                                               לשלוח הזמנה
                                        </Button>
                                    </ButtonToolbar>
                                </Modal>
                            </Col>
                            <Col md={6} sm={12} lg={6} xs={12}>
                                <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse', padding: '15px'}}>
                                    <Button color='primary' outline onClick={(e) => this.props.close()}>
                                        לחזור
                                    </Button>
                                </ButtonToolbar>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>



            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        //data: state.equipment.data.equip,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentTableForOrdering))